import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { CommonratingsedanComponent } from './commonratingsedan/commonratingsedan.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonCompModule } from '../common/common-comp.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxIonicImageViewerModule } from 'ngx-ionic-image-viewer';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonratingbusComponent } from './commonratingbus/commonratingbus.component';
import { CommonratingvanComponent } from './commonratingvan/commonratingvan.component';
import { CommonratingsuvComponent } from './commonratingsuv/commonratingsuv.component';
import { CommonratingtruckDoubleComponent } from './commonratingtruck-double/commonratingtruck-double.component';
import { CommonratingtruckSingleComponent } from './commonratingtruck-single/commonratingtruck-single.component';



@NgModule({
  declarations: [
    CommonratingsedanComponent, 
    CommonratingbusComponent, 
    CommonratingvanComponent, 
    CommonratingsuvComponent, 
    CommonratingtruckDoubleComponent, 
    CommonratingtruckSingleComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CommonCompModule,
    NgSelectModule,
    NgxIonicImageViewerModule,
    TranslateModule.forChild({
      extend: true,
    }),
    NgxMaskModule.forRoot(),
  ],
  exports: [
    CommonratingsedanComponent,
    CommonratingbusComponent, 
    CommonratingvanComponent, 
    CommonratingsuvComponent, 
    CommonratingtruckDoubleComponent, 
    CommonratingtruckSingleComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CommonratingcomponentsModule { }
